<template>
    <div class="carBox carBoxLeft">
        <div class="newBox">
        <div class="searchBox">

            <div class="searchGroup">
                <label>IP地址：</label>
                <el-input v-model="search_Obj.f_ip_str" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
        </div>
    <el-card class="box-card">
        <div class="mainBody">
        <div class="btnBox">
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
            <div class="dataBox">
                                <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                                    <el-table-column type="selection" align="center" width="50"></el-table-column>
                                    <el-table-column prop="ip_str" label="IP地址" sortable="custom"></el-table-column>
                                    <el-table-column prop="limit_visit" label="访问限制次数" sortable="custom"></el-table-column>
                                    <el-table-column prop="remark" label="备注"></el-table-column>
                                    <el-table-column prop="create_time" label="添加时间" sortable="custom"></el-table-column>
                                    <el-table-column label="操作" width="240" align="center">
                                        <template slot-scope="scope">
                                            <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
            <div class="pageBox">
                                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                            </div>
            <VisitInfo
                                width="800px"
                                title="查看访问情况"
                                :isshow="infoshow"
                                @on-close="closeInfoDialog">
                            </VisitInfo>
        </div>
    </el-card>
</div>
        <Edit
                            width="600px"
                            :id="model_id"
                            :title="edit_title"
                            :isshow="editshow"
                            @on-close="closeEditDialog"
                            @on-save-ok="saveOk">
                        </Edit>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import VisitInfo from "./visitinfo"
import listutil from "@/libs/listutil"

export default {
    name: 'visitLimitList',
    mixins: [listutil],
    components: {Edit, VisitInfo, Btns, LabBtns},
    data() {
        return {
            m_name: '访问限制',
            menu_id: 2400,
            list_url: "/api/admin/visitlimit/list",
            search_Obj: {
                f_ip_str: '',
            },
            del_Obj:{
                url:'/api/admin/visitlimit/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
        };
    },
    methods: {
        visitInfo(){
            this.infoshow = true
        }
    }
};
</script>